import React, { Fragment } from "react";
import PropTypes from "prop-types";

import { materialType } from "~/constants/prop-types";

import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Clear";

import InlineToolbar from "~/components/InlineToolbar";
import MaterialRenderer from "~/components/MaterialRenderer";

import { styled } from "@mui/material/styles";

const Title = styled(Typography)(props => ({
  paddingLeft: props.theme.spacing(2),
  marginLeft: 0,
  marginRight: "auto"
}));

const Header = styled(DialogTitle)(props => ({
  position: "relative",
  margin: 0,
  padding: 0,
  display: "flex",
  alignItems: "center"
}));

const StyledButton = styled(Button)(({ theme }) => {
  return {
    "&:focus-visible": {
      outline: theme.outline(),
      outlineOffset: "-2px"
    }
  };
});

const StyledIconButton = styled(IconButton)(({ theme }) => {
  return {
    "&:focus-visible": {
      outline: theme.outline(),
      outlineOffset: "-2px"
    }
  };
});

function ShowModal({ classes, hideModal, material, onEdit, onAbort, kind }) {
  return (
    <>
      <Header>
        <Title variant="h6" id={`${kind}-modal-title`}>
          Details: {material.title}
        </Title>

        <InlineToolbar>
          <StyledIconButton onClick={hideModal} size="large" aria-label="Schließen">
            <CloseIcon />
          </StyledIconButton>
        </InlineToolbar>
      </Header>

      <DialogContent>
        <MaterialRenderer {...material} />
      </DialogContent>

      <DialogActions>
        <StyledButton color="primary" onClick={onEdit(material)}>
          Bearbeiten
        </StyledButton>
        <StyledButton color="primary" onClick={onAbort}>
          Schließen
        </StyledButton>
      </DialogActions>
    </>
  );
}

ShowModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  classes: PropTypes.object,
  material: materialType,
  onEdit: PropTypes.func,
  onAbort: PropTypes.func,
  kind: PropTypes.string.isRequired
};

export default ShowModal;
